var exports = {
  "R": "ditherHost__elPPnF",
  "F": "ditherBackground__piHv4J",
};

module.exports = exports;
